import { useEffect, useState } from 'react';
import { RootState, useSelector } from '../../redux/store';
import type { ValueFormatterParams } from 'ag-grid-community';
import type { OrganizationBaseType } from '../../types/organizationBase';
import type { OrganizationUserType } from '../../types/user';

const OrganizationUserCellRenderer = (params: ValueFormatterParams): string => {
  const organizations: OrganizationUserType[] | undefined = params.value;
  // console.log(organizations);
  const { organizationBases } = useSelector((state: RootState) => state.organizationBase);
  const [displalyName, setDisplayName] = useState<string>('');

  useEffect(() => {
    if (organizations) {
      const organizationNames: string[] = organizations.map((org) => {
        // 会社を取得する
        const organizationBase: OrganizationBaseType | undefined = organizationBases?.find((base) => base.id === org.organizationBaseId);
        // 「会社名　組織詳細　商社名」の形にする
        const orgName: string = (organizationBase ? organizationBase.organizationBaseName : '') + org.organizationSuffixName;
        return orgName;
      });
      const names: string = organizationNames.join(', ');
      setDisplayName(names);
    }
  }, [organizations, organizationBases]);

  return displalyName;
};

export default OrganizationUserCellRenderer;
